<div class="kl-maprequest-download">
    <vl-form-grid mod-v-center mod-stacked>
        <vl-column width-xs="12" width="12">
            <vl-title tag-name="span" tag-style="h6">Planaanvraagzone</vl-title>
        </vl-column>
        <vl-column width-xs="12" width="12">
            <vl-input-group>
                <vl-select name="download-filetype" id="download-filetype" v-model="downloadFiletype" mod-no-placeholder mod-block>
                    <optgroup label="Lambert 72">
                        <option :value="parseValue(downloadUrl)" v-for="downloadUrl in lambert72DownloadUrls" :key="parseValue(downloadUrl)">
                            {{ downloadUrl.fileFormat }} - Lambert 72
                        </option>
                    </optgroup>
                    <optgroup label="Lambert 2008">
                        <option :value="parseValue(downloadUrl)" v-for="downloadUrl in lambert2008DownloadUrls" :key="parseValue(downloadUrl)">
                            {{ downloadUrl.fileFormat }} - Lambert 2008
                        </option>
                    </optgroup>
                </vl-select>
                <a :href="downloadFileUri" v-if="downloadFileUri && downloadFiletype" class="vl-button vl-button--narrow" download>Download</a>
            </vl-input-group>
        </vl-column>
    </vl-form-grid>
</div>
